/**
 * Created by Jie Gao on 7/30/2019.
 */
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DragonTribeSoundConfig} from "../DragonTribeSoundConfig";
import {DragonTribeParsedGameData} from "../server/data/DragonTribeParsedGameData";
import {DragonTribeGameModuleConfig} from "../DragonTribeGameModuleConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {DTReelSymbolH} from "../symbols/DTReelSymbolH";

export class WildAttention extends ReelStopPresentationController {

    private _wilds:number[] = [];
    private _wildsOnReel:boolean[] = [];

    constructor(index:number) {
        super(index, "WildAttention");
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._wilds = [];
        this._wildsOnReel = data.wildOnReel;
        data.reels.forEach((reel:string[], i:number) => {
            this._wilds.push(reel.indexOf("W"));
        });
    }

    public onReelStopSymbolAttention(data:IReelStoppedData):void {
        if(!this._wildsOnReel[data.reelId]) {
            return;
        }

        const symbol:StateReelSymbol | null = Reels.getSymbol(data.reelId, this._wilds[data.reelId]);
        if(symbol == null) {
        debugger;
            throw new Error(`ReelExpansionController.onReelBounce(): Cannot find symbol at reelId = ${data.reelId}, symbolId = ${this._wilds[data.reelId]}.`);
        }
        if(data.symbols![0].symName === "W"){
            SlotGame.sound.playEffect(DragonTribeSoundConfig.WILD_LANDING);
            (<DTReelSymbolH>symbol).playEggEffect();
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
       this.dispatchCompleteEvent(data.reelId);
    }
}